import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=1ea6b352&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=ts&"
export * from "./edit.vue?vue&type=script&lang=ts&"
import style0 from "./edit.vue?vue&type=style&index=0&id=1ea6b352&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea6b352",
  null
  
)

export default component.exports